var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcons5(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.381 9.027C14.9936 8.81426 15.6375 8.70575 16.286 8.706C16.94 8.706 17.569 8.815 18.156 9.015M18.156 9.015C20.394 9.78 22 11.881 22 14.353C22 17.472 19.442 20 16.286 20H6.286C3.919 20 2 18.104 2 15.765C2 13.426 3.919 11.53 6.286 11.529C6.56458 11.5293 6.84249 11.5561 7.116 11.609M18.156 9.015C17.837 6.194 15.416 4 12.476 4C9.32 4 6.762 6.528 6.762 9.647C6.7617 10.3169 6.8816 10.9814 7.116 11.609M7.116 11.609C7.66922 11.7167 8.19588 11.9321 8.666 12.243",
    stroke: "#1C1D1F",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons5);
export default __webpack_public_path__ + "static/media/Icons-5.c33218992ee6c96c188ebc2b3b7e1a57.svg";
export { ForwardRef as ReactComponent };